
  import { Component, Vue } from 'vue-property-decorator'
  import { Role } from '@/store/user/models'
  import { mapGetters } from 'vuex'
  import ChangeLogDialog from '@/components/ChangeLogDialog.vue'
  import CircularImage from '@/components/tutorial/CircularImage.vue'

@Component({
  components: {
    CircularImage,
    ChangeLogDialog,
  },
  computed: {
    ...mapGetters('user', ['roles']),
    ...mapGetters('app', ['isMobile']),
  },
})
  export default class Home extends Vue {
  isMobile!: boolean
  roles!: Array<Role>
  img = require('@/assets/genio/welcome.svg')

  get width () {
    const { isMobile } = this

    return isMobile ? 250 : 300
  }

  get height () {
    const { isMobile } = this
    return isMobile ? 250 : 300
  }

  get calculatedSize () {
    if (this.isMobile) return 400

    // Base size para resoluciones estándar (1920px)
    const baseSize = 650

    // Obtener el ancho actual de la pantalla
    const screenWidth = this.$vuetify.breakpoint.width
    console.log(screenWidth)
    // Para pantallas de alta resolución (más de 1920px), escalar proporcionalmente
    if (screenWidth > 1700) {
      // Factor de escala: 10% más grande por cada 500px adicionales
      const scaleFactor = 1 + ((screenWidth - 1920) / 500) * 0.1
      // Limitar el factor de escala a un máximo de 1.5 (50% más grande)
      return Math.min(baseSize * scaleFactor, baseSize * 1.5)
    }

    return baseSize
  }

  get menu () {
    const { isMobile } = this

    if (isMobile) {
      return [
        { icon: '$lead', process: 'lead', tooltip: 'Leads', link: 'leads' },
        { icon: '$appraisal', process: 'appraisal', tooltip: 'Tasaciones', link: 'tasaciones' },
        { icon: '$inspection', process: 'inspection', tooltip: 'Inspecciones', link: 'inspección' },
        { icon: '$negotiation_icon', process: 'negotiation', tooltip: 'Negociaciones', link: 'negociación' },
        { icon: '$purchase', process: 'purchase', tooltip: 'Compra', link: 'compra' },
        { icon: '$enablement', process: 'enablement', tooltip: 'Habilitación', link: 'habilitación' },
        { icon: '$kpi_icon', process: 'kpi', tooltip: 'KPIs', link: 'kpi' },
        { icon: '$publications', process: 'publications', tooltip: 'Publicaciones', link: 'publicaciones' },
      ]
    }

    return [
          { icon: '$lead', process: 'lead', tooltip: 'Leads', link: 'leads' },
          { icon: '$appraisal', process: 'appraisal', tooltip: 'Tasaciones', link: 'tasaciones' },
          { icon: '$inspection', process: 'inspection', tooltip: 'Inspecciones', link: 'inspección' },
          { icon: '$negotiation_icon', process: 'negotiation', tooltip: 'Negociaciones', link: 'negociación' },
          { icon: '$purchase', process: 'purchase', tooltip: 'Compra', link: 'compra' },
          { icon: '$enablement', process: 'enablement', tooltip: 'Habilitación', link: 'habilitación' },
          { icon: '$kpi_icon', process: 'kpi', tooltip: 'KPIs', link: 'kpi' },
          { icon: '$publications', process: 'publications', tooltip: 'Publicaciones', link: 'publicaciones' },
          { icon: '$reserve', process: 'reserve', tooltip: 'Reservas', link: 'reservas' },
          { icon: '$financing', process: 'financing', tooltip: 'Financiamientos', link: 'financiamiento' },
          { icon: '$treasurer', process: 'treasure', tooltip: 'Tesorería', link: 'tesorería' },
          { icon: '$all', process: 'all', tooltip: 'Todos', link: 'todos' },
          { icon: '$sell', process: 'sell', tooltip: 'Ventas', link: 'venta' },

        ]
  }
  }
